import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIcon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconIcon"><Path fillRule="evenodd" clipRule="evenodd" d="M17 6H22V21H2V6H7V2H17V6ZM11.25 12.75H9V14.25H11.25V16.5H12.75V14.25H15V12.75H12.75V10.5H11.25V12.75ZM8.5 6H15.5V3.5H8.5V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIcon;
